import Machine from './index'

import {deviceBuyIp, getDeviceList, getGradePrice, getGroupList,  getGrade, getDeviceConfig} from '@/services/newMachine'
import {action, computed, observable} from 'mobx'
import {message, Modal} from "antd";

export interface  Grade{
  "id": number
  "name": string
  "sort": number
  "band_width": number
}


class IPService extends Machine{
  getPricesAPI=getGradePrice
  getGroupListAPI=getGroupList
  getDeviceListAPI=getDeviceList
  deviceBuyAPI = deviceBuyIp
  productId = 31

  @observable grade_id: string

  @computed get pricesParams():object {
    return{
      grade_id: this.grade_id
    }
  }
  // 生成订单参数
  @computed get buyParams():object {
    return{
      roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id,
      groupId: this.groupId,
      priceId: this.selectPrice && this.selectPrice.id,
      payType: this.payType,
      priceType: 1,
      clientType: 1,
      buyIds: this.selectedIds.join(','),
      returnUrl: '/'
    }
  }

  @observable gradeList: Grade[] = []


  // 切换购买ip服务级别
  @action.bound async changeGrade(id: string) {

    this.selectPrice = undefined
    let params = {
        grade_id:id
    }
    const [error, result] = await getGradePrice(params)
    if(error) return ;
    this.prices = result.price_list
  }

  @action.bound async initIPService() {
    await this.getGrade()
    this.init();
  }

  @action.bound async getGrade() {
    let params = {
      product_id: this.productId
    }
    const [error, result] = await getGrade(params)
    if(error) return ;
    this.gradeList = result.grade_list || []
    this.grade_id = this.gradeList[0] && result.grade_list[0].id
  }

  // 点击立即购买
  @action.bound async deviceBuyIpService() {
    if(!this.priceId && this.productId !== 0) {
      message.error('请选择资费')
      return ;
    }
    if(!this.selectedIds.length){
      message.error('请选择购买服务的设备')
      return ;
    }
    if(!this.payType){
      message.error('请选择支付方式')
      return ;
    }
    let params  = {
      priceId: this.selectPrice && this.selectPrice.id
    }
    // 验证web配置
    const [error, result] = await getDeviceConfig(params)
    if(error) return ;
    const canUseNum:number|null = result.price_max_num ? result.price_max_num - result.price_usable_num : null;
    const sum: number = result.ip_reuse_num* result.ip_pool_num- result.ip_usable_num;
    const user:number = result.ip_pool_num - result.use_stock_num

    if(canUseNum !== null && canUseNum < this.selectedIds.length){
      Modal.error({
        title: '此服务已购买超过资费次数，无法继续购买，请购买其他服务',
        content: `如需购买请联系客服QQ：2207685072`,
      });
      return ;
    }

    if(sum < this.selectedIds.length) {
      Modal.error({
        title: '此服务购买设备已达最大限制，无法继续购买',
        content: `如需购买请联系客服QQ：2207685072`,
      });
      return ;
    }

    if(user<this.selectedIds.length){
      Modal.error({
        title: '此服务无法继续购买',
        content: `如需购买请联系客服QQ：2207685072`,
      });
      return ;
    }

    // 判断有效时常超过设备剩余时长
    let isMatch = false
    for(let i = 0; i<this.deviceList.length; i++) {
      if(this.selectedIds.includes(this.deviceList[i].id)){
        let time = this.deviceList[i].endTime - Math.floor(new Date().getTime() / 1000)
        if(time < ((this.selectPrice && this.selectPrice.period) || 0)) {
          isMatch = true
          break;
        }
      }
    }

    if(isMatch){
      Modal.confirm({
        title: '提示',
        content: `购买此服务的有效时长超过设备剩余时长，是否继续支付`,
        okText: '继续支付',
        cancelText: '取消',
        onOk: () => {
          this.deviceBuy()
        }
      });
      return ;
    }
    // 生成订单
    this.deviceBuy()
  }

}

export default IPService
